// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import DatePicker from '@mui/lab/DatePicker';
import SelMemberDialog from './SelMemberDialog';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';

import dayjs from 'dayjs';

import SelFolderDialog from './SelFolderDialog';
import DatepickerWithCheckbox from './DatePickerWithCheckBox';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export default function ReportTab(props) {
  const { sysID } = props;

  const folders = props.folders || [];

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const curDept = gState?.depts?.find(d => d.DeptCode == sysID);
  const adminLevel = curDept?.AdminLevel || 0;
  const isDataAdmin = ((adminLevel & DmsCommon.SystemAdminEnum.saData) == DmsCommon.SystemAdminEnum.saData);
  const isSecurtyAdmin = ((adminLevel & DmsCommon.SystemAdminEnum.saSecurity) == DmsCommon.SystemAdminEnum.saSecurity);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [actTabValue, setActTabValue] = useState(0);

  const [includeFolderRight, setIncludeFolderRight] = useState(false);
  const [folderListUserOptValue, setFolderListUserOptValue] = useState("all");



  const handleTabChange = (event, newValue) => {
    setActTabValue(newValue);
  };

  const [openSelectFolderPrintUserDialog, setOpenSelectFolderPrintUserDialog] = useState(false);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }

  const [checkoutCompanyList, setCheckoutCompanyList] = useState([]);
  const [checkoutHandlerList, setCheckoutHandlerList] = useState([]);
  const [sentOutReasonList, setSentOutReasonList] = useState([]);
  const [checkedByList, setCheckedByList] = useState([]);
  const [ourRefList, setOurRefList] = useState([]);

  useEffect(() => {
    // console.log("useEffect ReportTab(did mounted)");
    const xFunc = async () => {
      setShowLoading(true);

      try {

        const vData = await DmsService.getRptCheckHistOptionsPromise(gState.sessionID, sysID);

        setCheckoutCompanyList(["<All>", ...vData.PtyList]);
        setCheckoutHandlerList(["<All>", ...vData.HandledByList]);
        setSentOutReasonList(["<All>", ...vData.SentOutReasonList]);
        setCheckedByList(["<All>", ...vData.CheckedByList]);
        setOurRefList(["<All>", ...vData.OurRefList]);


        setShowLoading(false);

      } catch (e) {
        setShowLoading(false);

        onCatchPromiseError(e);
      }



    }
    xFunc();


  }, []);



  const handleFolderListUserOptChange = (e) => {
    setFolderListUserOptValue(e.target.value);
  };

  const [openSelectUserDialog, setOpenSelectUserDialog] = useState(false);
  const [members, setMembers] = useState([]);

  const handleSelectFolderPrintUserClick = () => {

    const xFunc = async () => {
      setShowLoading(true);

      try {
        const data = await DmsService.getMembersPromise(gState.sessionID, sysID, false);

        setShowLoading(false);

        setMembers(data);
        setOpenSelectUserDialog(true);

      } catch (e) {
        setShowLoading(false);
        onCatchPromiseError(e);
      }

    }
    xFunc();
  }

  const [selectUser, setSelectUser] = useState({});

  const handleSelectUser = (aUsers) => {
    setOpenSelectUserDialog(false);

    console.log(' handleSelectUser ~ aUsers:', aUsers);
    if (aUsers.length === 1) {
      setSelectUser(aUsers[0]);
    }
  }

  const handlePrintOrExcel = (aIsPrint) => {
    const xFunc = async () => {
      const dt = new Date();
      const offset = dt.getTimezoneOffset() * 60 * 1000;
      const localTime = new Date(dt.getTime() - offset);
      const vPrintDT = localTime.toISOString().replace("Z", ""); // remove timezone info


      if (actTabValue === 0) {
        // User Logon Report

        let vUserID = "";
        if (includeFolderRight === true && folderListUserOptValue === "select") {
          vUserID = selectUser?.UserID || "";
        }

        setShowLoading(true);

        try {
          const data = await DmsService.printFolderListPromise(
            gState.sessionID, sysID, includeFolderRight,
            showAuthFolderOnly,
            vUserID, vPrintDT)

          setShowLoading(false);

          const blob = new Blob([data]);
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = 'folderListRpt.pdf';
          a.click();

        } catch (e) {

          setShowLoading(false);
          onCatchPromiseError(e);
          return;
        }


      } else if (actTabValue === 1) {
        // Check Out History Report

        let vUserID = "";
        if (includeFolderRight === true && folderListUserOptValue === "select") {
          vUserID = selectUser?.UserID || "";
        }

        setShowLoading(true);

        try {
          let vCheckoutNotReturnVal = 2; // default to <All>
          if (checkoutNotReturned === "Yes") {
            vCheckoutNotReturnVal = 1; // returned
          } else if (checkoutNotReturned === "No") {
            vCheckoutNotReturnVal = 0; // not returned
          }

          let vCompList = []
          if (selectedCheckoutCompany.length > 0 && selectedCheckoutCompany[0] !== "<All>") {
            vCompList = selectedCheckoutCompany;
          }
          const vHandledBy = selectedCheckoutHandler !== "<All>" ? selectedCheckoutHandler : "";
          const vSentReason = selectedCheckoutSentReason !== "<All>" ? selectedCheckoutSentReason : "";
          const vOurRef = checkoutOurRef !== "<All>" ? checkoutOurRef : "";
          const vCheckedBy = checkoutCheckedBy !== "<All>" ? checkoutCheckedBy : "";

          const vReqDTFrom = enabledCheckoutRequestDateFrom ? selectedCheckoutRequestDateFrom : null;
          const vReqDTTo = enabledCheckoutRequestDateTo ? selectedCheckoutRequestDateTo : null;
          const vSentOutDTFrom = enabledCheckoutSentOutDateFrom ? selectedCheckoutSentOutDateFrom : null;
          const vSentOutDTTo = enabledCheckoutSentOutDateTo ? selectedCheckoutSentOutDateTo : null;
          const vReturnDTFrom = enabledCheckoutReturnDateFrom ? selectedCheckoutReturnDateFrom : null;
          const vReturnDTTo = enabledCheckoutReturnDateTo ? selectedCheckoutReturnDateTo : null;

          // console.log("vReqDTFrom", vReqDTFrom);
          // console.log("vReqDTTo", vReqDTTo);
          // console.log("vSentOutDTFrom", vSentOutDTFrom);
          // console.log("vSentOutDTTo", vSentOutDTTo);
          // console.log("vReturnDTFrom", vReturnDTFrom);
          // console.log("vReturnDTTo", vReturnDTTo);


          // const vReqDT1Z = new Date(vReqDTFrom - offset);


          // const vReqDT1 = vReqDTFrom.toISOString().replace("Z", ""); // remove timezone info
          // console.log("vReqDT1", vReqDT1);
          // const vReqDT1x = dayjs(vReqDT1).format("YYYY-MM-DDTHH:mm:ss");
          // console.log("vReqDT1x", vReqDT1x);


          if (aIsPrint) {
            const data = await DmsService.printCheckoutHistPromise(
              gState.sessionID, sysID,
              vCompList,
              vHandledBy,
              vReqDTFrom, vReqDTTo,
              vSentOutDTFrom, vSentOutDTTo,
              vSentReason, vOurRef,
              vReturnDTFrom, vReturnDTTo,
              vCheckedBy, vCheckoutNotReturnVal,
              selFolderID, vPrintDT)

            setShowLoading(false);

            const blob = new Blob([data]);
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = 'checkHistRpt.pdf';
            a.click();


          } else {
            const data = await DmsService.exportCheckoutHistPromise(
              gState.sessionID, sysID,
              vCompList,
              vHandledBy,
              vReqDTFrom, vReqDTTo,
              vSentOutDTFrom, vSentOutDTTo,
              vSentReason, vOurRef,
              vReturnDTFrom, vReturnDTTo,
              vCheckedBy, vCheckoutNotReturnVal,
              selFolderID, vPrintDT)

            setShowLoading(false);

            const blob = new Blob([data]);
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = 'checkHistRpt.xlsx';
            a.click();


          }

        } catch (e) {

          setShowLoading(false);
          onCatchPromiseError(e);
          return;
        }

      }
    }
    xFunc();
  }

  const handlePrintClick = () => {
    handlePrintOrExcel(true);
  }

  const handleExcelClick = () => {
    handlePrintOrExcel(false);
  }

  const [showAuthFolderOnly, setShowAuthFolderOnly] = useState(false);

  const [dateFrom, setDateFrom] = useState(null);


  const [selectedCheckoutCompany, setSelectedCheckoutCompany] = useState(["<All>"]);
  const handleChangeCheckoutCompany = (event) => {
    let selList = event.target.value;

    const lastItem = selList[selList.length - 1];
    if (lastItem === "<All>") {
      // If <All> is selected, clear all other selections
      selList = [checkoutCompanyList[0]]; // reset to <All>
    } else if (selList.length > 1 && selList.includes("<All>")) {
      // If <All> is selected along with other items, remove <All>
      selList = selList.filter(item => item !== "<All>");
    }

    setSelectedCheckoutCompany(selList);
  }

  // const vToday = new Date();
  // vToday.setHours(0, 0, 0, 0);

  // const vOffset = vToday.getTimezoneOffset() * 60 * 1000;
  // const vTodayLocal = new Date(vToday.getTime() - vOffset);

  // let vFirstOfMonth = new Date(vTodayLocal.getFullYear(), vTodayLocal.getMonth(), 1);
  // vFirstOfMonth = new Date(vFirstOfMonth.getTime() - vOffset);
  const vFirstOfMonth = dayjs().startOf('month').toDate();
  const vTodayLocal = dayjs().toDate();
  // console.log("vFirstOfMonth", vFirstOfMonth);
  // console.log("vTodayLocal", vTodayLocal);

  const [selectedCheckoutHandler, setSelectedCheckoutHandler] = useState("<All>");
  const handleChangeCheckoutHandler = (event) => {
    setSelectedCheckoutHandler(event.target.value);
  }

  const [selectedCheckoutRequestDateFrom, setSelectedCheckoutRequestDateFrom] = useState(vFirstOfMonth);
  const [enabledCheckoutRequestDateFrom, setEnabledCheckoutRequestDateFrom] = useState(true);
  const handleChangeCheckoutRequestDateFrom = (newValue) => {
    setSelectedCheckoutRequestDateFrom(newValue);
  }
  const handleEnableCheckoutRequestDateFrom = (newValue) => {
    setEnabledCheckoutRequestDateFrom(newValue);
  }

  const [selectedCheckoutRequestDateTo, setSelectedCheckoutRequestDateTo] = useState(vTodayLocal);
  const [enabledCheckoutRequestDateTo, setEnabledCheckoutRequestDateTo] = useState(true);
  const handleChangeCheckoutRequestDateTo = (newValue) => {
    setSelectedCheckoutRequestDateTo(newValue);
  }
  const handleEnableCheckoutRequestDateTo = (newValue) => {
    setEnabledCheckoutRequestDateTo(newValue);
  }

  const [selectedCheckoutSentOutDateFrom, setSelectedCheckoutSentOutDateFrom] = useState(vTodayLocal);
  const [enabledCheckoutSentOutDateFrom, setEnabledCheckoutSentOutDateFrom] = useState(false);
  const handleChangeCheckoutSentOutDateFrom = (newValue) => {
    setSelectedCheckoutSentOutDateFrom(newValue);
  }
  const handleEnableCheckoutSentOutDateFrom = (newValue) => {
    setEnabledCheckoutSentOutDateFrom(newValue);
  }

  const [selectedCheckoutSentOutDateTo, setSelectedCheckoutSentOutDateTo] = useState(vTodayLocal);
  const [enabledCheckoutSentOutDateTo, setEnabledCheckoutSentOutDateTo] = useState(false);
  const handleChangeCheckoutSentOutDateTo = (newValue) => {
    setSelectedCheckoutSentOutDateTo(newValue);
  }
  const handleEnableCheckoutSentOutDateTo = (newValue) => {
    setEnabledCheckoutSentOutDateTo(newValue);
  }

  const [selectedCheckoutSentReason, setSelectedCheckoutSentReason] = useState("<All>");
  const handleChangeCheckoutSentReason = (event) => {
    setSelectedCheckoutSentReason(event.target.value);
  }

  const [checkoutOurRef, setCheckoutOurRef] = useState("<All>");
  const handleChangeCheckoutOurRef = (event) => {
    setCheckoutOurRef(event.target.value);
  }

  const [selectedCheckoutReturnDateFrom, setSelectedCheckoutReturnDateFrom] = useState(vTodayLocal);
  const [enabledCheckoutReturnDateFrom, setEnabledCheckoutReturnDateFrom] = useState(false);
  const handleChangeCheckoutReturnDateFrom = (newValue) => {
    setSelectedCheckoutReturnDateFrom(newValue);
  }
  const handleEnableCheckoutReturnDateFrom = (newValue) => {
    setEnabledCheckoutReturnDateFrom(newValue);
  }

  const [selectedCheckoutReturnDateTo, setSelectedCheckoutReturnDateTo] = useState(vTodayLocal);
  const [enabledCheckoutReturnDateTo, setEnabledCheckoutReturnDateTo] = useState(false);
  const handleChangeCheckoutReturnDateTo = (newValue) => {
    setSelectedCheckoutReturnDateTo(newValue);
  }
  const handleEnableCheckoutReturnDateTo = (newValue) => {
    setEnabledCheckoutReturnDateTo(newValue);
  }

  const checkoutNotReturnedList = [
    "<All>", "Yes", "No",
  ];

  const [checkoutNotReturned, setCheckoutNotReturned] = useState("<All>");
  const handleChangeCheckoutNotReturned = (event) => {
    setCheckoutNotReturned(event.target.value);
  }


  const [checkoutCheckedBy, setCheckoutCheckedBy] = useState("<All>");
  const handleChangeCheckoutCheckedBy = (event) => {
    setCheckoutCheckedBy(event.target.value);
  }

  const [selFolderPath, setSelFolderPath] = useState("");

  const [checkoutDocOptions, setCheckoutDocOptions] = useState("1");
  const handleChangeCheckoutDocOptions = (event) => {
    setCheckoutDocOptions(event.target.value);
  }

  const [openFolderDialog, setOpenFolderDialog] = useState(false);

  const [selFolderID, setSelFolderID] = useState(0);
  const [folderPath, setFolderPath] = useState("");

  const handleSelectFolderID = (aFolderID) => {
    // console.log("aFolderID", aFolderID);

    setOpenFolderDialog(false);

    const vSelFolder = folders.find(f => f.id === aFolderID);
    // console.log("vFolder", vFolder);

    if (vSelFolder) {

      setSelFolderID(aFolderID);
      setSelFolderPath(vSelFolder.FolderPath);
    }

  }

  let disabledPrint = false;
  if (actTabValue === 0) {
    disabledPrint = includeFolderRight && folderListUserOptValue === "select";
  } else if (actTabValue === 1) {
    disabledPrint = (checkoutDocOptions === "2" && selFolderPath === "")
  }

  let visibleExcel = false;
  if (actTabValue === 1) {
    visibleExcel = true;
  }

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column',
      height: "65vh"
    }} >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <SelMemberDialog
        open={openSelectUserDialog}
        onClose={() => { setOpenSelectUserDialog(false) }}
        members={members}
        groups={[]}
        disableGroupTab
        disableMultiSelectMember
        onSelect={handleSelectUser}
      />

      <SelFolderDialog
        open={openFolderDialog}
        onClose={() => setOpenFolderDialog(false)}
        folders={folders}
        iniFolderID={selFolderID}
        disableAllFolder
        disablePhyLocFolder
        onSelectFolderID={handleSelectFolderID}
      />

      <Box
        sx={{ flexGrow: 1, width: "100%", display: 'flex', minHeight: "600px" }}
      >
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={actTabValue}
          onChange={handleTabChange}
          aria-label="vertTabs"
          sx={{ borderRight: 1, borderColor: 'divider', width: "200px" }}
        >
          <Tab label="Folder List" {...a11yProps(0)} />
          <Tab label="Check Out History" {...a11yProps(1)} />
          {/* <Tab label="User Logon Report" {...a11yProps(1)} /> */}
        </Tabs>
        <TabPanel value={actTabValue} index={0}>
          <Box sx={{ m: 3 }} >
            <FormControl>
              <FormLabel id="folderListOptionLabel">Options</FormLabel>
              <FormControlLabel control={<Checkbox
                checked={includeFolderRight}
                onChange={(event) => { setIncludeFolderRight(event.target.checked) }} />}
                label="Print folder's access right" />
              <RadioGroup
                value={folderListUserOptValue}
                onChange={handleFolderListUserOptChange}
              >
                <FormControlLabel value="all" disabled={!includeFolderRight} control={<Radio />} label="All users" />
                <FormControlLabel value="select" disabled={!includeFolderRight} control={<Radio />} label="Selected user" />
              </RadioGroup>

              <TextField
                // select
                // defaultValue="EUR"
                disabled={!includeFolderRight}
                sx={{ ml: 2, mt: 2, width: "400px" }}
                value={selectUser?.FullName || ""}

                InputProps={{
                  readOnly: true,
                  endAdornment:
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleSelectFolderPrintUserClick}
                        onMouseDown={() => event.preventDefault()}
                        edge="end"
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                }}
              >
              </TextField>
              <FormControlLabel control={<Checkbox
                disabled={!includeFolderRight}
                checked={showAuthFolderOnly}
                onChange={(event) => { setShowAuthFolderOnly(event.target.checked) }} />}
                label="Show authorized folder only" />

            </FormControl>


          </Box>
        </TabPanel>
        <TabPanel value={actTabValue} index={1} >
          <Box sx={{ m: 3, width: "700px" }} >
            <Grid container spacing={{ xs: 1 }}  >
              <Grid item xs={12}>
                <TextField
                  label="Company / Dept/ Property"
                  value={selectedCheckoutCompany}
                  onChange={handleChangeCheckoutCompany}
                  select
                  SelectProps={{
                    multiple: true,
                  }}
                  fullWidth
                  // sx={{ width: "600px" }}
                  InputLabelProps={{ shrink: true, }}
                >
                  {checkoutCompanyList.map((d) => (
                    <MenuItem key={d} value={d} >
                      {d}
                    </MenuItem>
                  ))}
                </TextField>

              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Handled by"
                  value={selectedCheckoutHandler}
                  onChange={handleChangeCheckoutHandler}
                  select
                  fullWidth
                  InputLabelProps={{ shrink: true, }}
                >
                  {checkoutHandlerList.map((d) => (
                    <MenuItem key={d} value={d} >
                      {d}
                    </MenuItem>
                  ))}
                </TextField>

              </Grid>

              <Grid item xs={6}>

                <DatepickerWithCheckbox
                  label="Request Date From"
                  dateValue={selectedCheckoutRequestDateFrom}
                  enabledDate={enabledCheckoutRequestDateFrom}
                  onDateChange={handleChangeCheckoutRequestDateFrom}
                  onEnableDateChange={handleEnableCheckoutRequestDateFrom}
                />

              </Grid>
              <Grid item xs={6}>
                <DatepickerWithCheckbox
                  label="Request Date To"
                  dateValue={selectedCheckoutRequestDateTo}
                  enabledDate={enabledCheckoutRequestDateTo}
                  onDateChange={handleChangeCheckoutRequestDateTo}
                  onEnableDateChange={handleEnableCheckoutRequestDateTo}
                />
              </Grid>

              <Grid item xs={6}>
                <DatepickerWithCheckbox
                  label="Sent Out Date From"
                  dateValue={selectedCheckoutSentOutDateFrom}
                  enabledDate={enabledCheckoutSentOutDateFrom}
                  onDateChange={handleChangeCheckoutSentOutDateFrom}
                  onEnableDateChange={handleEnableCheckoutSentOutDateFrom}
                />

              </Grid>
              <Grid item xs={6}>
                <DatepickerWithCheckbox
                  label="Sent Out Date To"
                  dateValue={selectedCheckoutSentOutDateTo}
                  enabledDate={enabledCheckoutSentOutDateTo}
                  onDateChange={handleChangeCheckoutSentOutDateTo}
                  onEnableDateChange={handleEnableCheckoutSentOutDateTo}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Sent Reason"
                  value={selectedCheckoutSentReason}
                  onChange={handleChangeCheckoutSentReason}
                  select
                  fullWidth
                  // sx={{ width: "600px" }}
                  InputLabelProps={{ shrink: true, }}
                >
                  {sentOutReasonList.map((d) => (
                    <MenuItem key={d} value={d} >
                      {d}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Our Ref. No."
                  value={checkoutOurRef}
                  onChange={handleChangeCheckoutOurRef}
                  select
                  fullWidth
                  // sx={{ width: "600px" }}
                  InputLabelProps={{ shrink: true, }}
                >
                  {ourRefList.map((d) => (
                    <MenuItem key={d} value={d} >
                      {d}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={6}>
                <DatepickerWithCheckbox
                  label="Return Date From"
                  dateValue={selectedCheckoutReturnDateFrom}
                  enabledDate={enabledCheckoutReturnDateFrom}
                  onDateChange={handleChangeCheckoutReturnDateFrom}
                  onEnableDateChange={handleEnableCheckoutReturnDateFrom}
                />
              </Grid>
              <Grid item xs={6}>
                <DatepickerWithCheckbox
                  label="Return Date To"
                  dateValue={selectedCheckoutReturnDateTo}
                  enabledDate={enabledCheckoutReturnDateTo}
                  onDateChange={handleChangeCheckoutReturnDateTo}
                  onEnableDateChange={handleEnableCheckoutReturnDateTo}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Not Yet Returned"
                  value={checkoutNotReturned}
                  onChange={handleChangeCheckoutNotReturned}
                  select
                  fullWidth
                  // sx={{ width: "600px" }}
                  InputLabelProps={{ shrink: true, }}
                >
                  {checkoutNotReturnedList.map((d) => (
                    <MenuItem key={d} value={d} >
                      {d}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Checked By"
                  value={checkoutCheckedBy}
                  onChange={handleChangeCheckoutCheckedBy}
                  select
                  fullWidth
                  // sx={{ width: "600px" }}
                  InputLabelProps={{ shrink: true, }}
                >
                  {checkedByList.map((d) => (
                    <MenuItem key={d} value={d} >
                      {d}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} >
                <RadioGroup
                  row
                  value={checkoutDocOptions}
                  onChange={handleChangeCheckoutDocOptions}
                >
                  <FormControlLabel value="1" control={<Radio />} label="Documents in All Folders" />
                  <FormControlLabel value="2" control={<Radio />} label="Documents in Select Folder" />
                  <TextField
                    label=""
                    variant="standard"
                    // required
                    disabled={checkoutDocOptions == '1'}
                    fullWidth
                    value={selFolderPath}
                    InputLabelProps={{ shrink: true, }}

                    InputProps={{
                      readOnly: true,
                      endAdornment:
                        <InputAdornment position="end">
                          <IconButton
                            disabled={checkoutDocOptions == '1'}
                            onClick={() => { setOpenFolderDialog(true) }}
                            onMouseDown={() => event.preventDefault()}
                            edge="end"
                          >
                            <FolderOpenIcon />
                          </IconButton>
                        </InputAdornment>
                    }}
                  />
                </RadioGroup>
              </Grid>
            </Grid>



          </Box>
        </TabPanel>
        {/* <TabPanel value={actTabValue} index={1} >
          <Box
            sx={{ m: 3, flexGrow: 1, width: "800px", display: 'flex', height: "400px" }}
          >

            <Grid container spacing={{ xs: 1 }}  >
              <Grid item xs={12}>
                Report Period
                <FormControl>

                </FormControl>

                <Paper elevation={3} sx={{ p: 1, m: 1, flex: "1" }} >
                  <DatePicker
                    label="Date From"
                    value={dateFrom}
                    onChange={(newValue) => {
                      setDateFrom(newValue);
                    }}
                    sx={{ width: 220 }}
                    renderInput={(params) => <TextField
                      InputLabelProps={{ shrink: true, }}
                      {...params} />}

                  />
                </Paper>
                <Paper elevation={3} sx={{ p: 1, m: 1 }} >
                  sdf
                </Paper>

              </Grid>
            </Grid>
          </Box>
        </TabPanel> */}
      </Box>
      <Box
        sx={{ width: "900px", display: 'flex' }}
      >
        <div style={{ flex: '1 0 0' }} />
        <Button variant="contained" disabled={disabledPrint} onClick={handlePrintClick} >Print</Button>
        <Button variant="contained"
          sx={{ ml: 1, display: visibleExcel ? 'block' : 'none' }}
          onClick={handleExcelClick} >Excel</Button>
      </Box>

    </Box >


  );
}

ReportTab.propTypes = {
  sysID: PropTypes.string,
  folders: PropTypes.array,
}
